export const SCHEMA_COLUMNS_LOAD_ALL = 'SCHEMA_COLUMNS_LOAD_ALL';
export const SCHEMA_COLUMNS_UPDATE_ONE = 'SCHEMA_COLUMNS_UPDATE_ONE';
export const SET_FILTER = 'SET_FILTER';
export const SCHEMA_ERRORS_LOAD_ALL = 'SCHEMA_ERRORS_LOAD_ALL';
export const VALIDATION_ERRORS_LOAD_ALL = 'VALIDATION_ERRORS_LOAD_ALL';
